/* tslint:disable */
/* eslint-disable */
/**
 * users
 * users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserDetailUserType
 */
export interface UserDetailUserType {
    /**
     * 
     * @type {string}
     * @memberof UserDetailUserType
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof UserDetailUserType
     */
    title?: string;
}

/**
 * Check if a given object implements the UserDetailUserType interface.
 */
export function instanceOfUserDetailUserType(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserDetailUserTypeFromJSON(json: any): UserDetailUserType {
    return UserDetailUserTypeFromJSONTyped(json, false);
}

export function UserDetailUserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserDetailUserType {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'title': !exists(json, 'title') ? undefined : json['title'],
    };
}

export function UserDetailUserTypeToJSON(value?: UserDetailUserType | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'title': value.title,
    };
}

